const state = {
  categories: [
    {
      code: "overview",
      title: "Overview",
      sub: true,
      tabs: []
    },
    {
      code: "network_performance",
      title: "Network Performance Indicators",
      sub: true,
      tabs: []
    },
    {
      code: "asset_data",
      title: "Asset Data",
      sub: true,
      tabs: []
    },
    {
      code: "asset_performance",
      title: "Asset Perfomance Indicators",
      sub: true,
      tabs: []
    }
  ],
  subCategories: {
    overview: [
      {
        title: "River Zone Network Map",
        tabs: [
          {
            title: "",
            code: "overview_river_zone",
            // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=51ffb878a4ae4095a87fcd3f03476bbb"
            url: "https://www.srapc-2d-webapp.geodemosolutions.com/"
          }
        ]
      },
      {
        title: "Data Quality Assessments",
        tabs: [
          {
            title: "",
            code: "overview_data_quality",
            url: "https://app.powerbi.com/reportEmbed?reportId=59f03a19-b23d-4134-b75d-704ab03f46fa&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
    ],
    network_performance: [
      {
        title: "Community Feedback",
        tabs: [
          {
            title: "Existing Data",
            code: "comm_feedback_existing_data",
            url: "https://app.powerbi.com/reportEmbed?reportId=fffce3a5-b188-4f91-b238-22ceb74e99fb&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "Potential Data",
            code: "comm_feedback_potential_data",
            url: "https://app.powerbi.com/reportEmbed?reportId=7c7aca86-5017-4185-ba04-405faf88fcfa&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Traffic Performance",
        tabs: [
          {
            title: "Existing Data",
            code: "trfk_perf_existing_data",
            url: "https://srapc-under-construction.geodemosolutions.com"
          },
          {
            title: "Potential Data",
            code: "trfk_perf_potential_data",
            url: "https://srapc-under-construction.geodemosolutions.com"
          }
        ]
      },
      {
        title: "Safety Data",
        tabs: [
          {
            title: "Existing Data",
            code: "safety_existing_data",
            url: "https://app.powerbi.com/reportEmbed?reportId=0d27b3b4-5162-454d-9db3-3778e9569d9e&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "Potential Data",
            code: "safety_potential_data",
            url: "https://srapc-under-construction.geodemosolutions.com"
          }
        ]
      },
      {
        title: "Heavy Vehicles",
        tabs: [
          {
            title: "Existing Data",
            code: "heavy_vhcl_existing_data",
            url: "https://srapc-under-construction.geodemosolutions.com"
          },
          {
            title: "Potential Data",
            code: "heavy_vhcl_potential_data",
            url: "https://srapc-under-construction.geodemosolutions.com"
          }
        ]
      }
    ],
    asset_data: [
      {
        title: "ITS",
        tabs: [
          {
            title: "INVENTORY",
            code: "its_inventory",
            url: "https://app.powerbi.com/reportEmbed?reportId=dfcb1801-167d-4606-beb0-8bc74a16dd9a&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "CONDITION",
            code: "its_condition",
            url: "https://app.powerbi.com/reportEmbed?reportId=ec12fe5a-85a5-4176-8ab7-9e2cdc686854&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D "
          },
          {
            title: "GIS",
            code: "its_gis",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=99b79f7c61794ae2b0bc55427e5f04a6"
          },
          {
            title: "TAMP",
            code: "its_tamp",
            url: "https://srapc-under-construction.geodemosolutions.com"
          },
          {
            title: "RAW DATA",
            code: "its_raw_data",
            url: "https://app.powerbi.com/reportEmbed?reportId=144591d1-ea08-49bd-9cbb-e416ad2f22e7&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Pavements",
        tabs: [
          {
            title: "INVENTORY",
            code: "pavements_inventory",
            url: "https://app.powerbi.com/reportEmbed?reportId=53a52226-87ff-41b5-844e-4c8bb0760ed7&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "CONDITION",
            code: "pavements_condition",
            url: "https://app.powerbi.com/reportEmbed?reportId=881c07a9-5433-447b-aad8-ca149fb03d56&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "GIS",
            code: "pavements_gis",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=75218493f525483f94e0e1171c70ea12"
          },
          {
            title: "TAMP",
            code: "pavements_tamp",
            url: "https://srapc-under-construction.geodemosolutions.com"
          },
          {
            title: "RAW DATA",
            code: "pavements_raw_data",
            url: "https://app.powerbi.com/reportEmbed?reportId=f046d0d3-dfb6-449e-b07e-389f6b4aa9af&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Corridors",
        tabs: [
          {
            title: "INVENTORY",
            code: "corridors_inventory",
            url: "https://app.powerbi.com/reportEmbed?reportId=3ddde391-2f04-4b1c-bd42-e3be4eaee733&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "CONDITION",
            code: "corridors_condition",
            url: "https://app.powerbi.com/reportEmbed?reportId=28c50666-cf39-4607-a7c4-f0bf93e0b5cc&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "GIS",
            code: "corridors_gis",
            // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=2b887c7f3066445e91917e4fafcbe891"
            url: "https://www.srapc-asset-corridors-webapp.geodemosolutions.com/"
          },
          {
            title: "TAMP",
            code: "corridors_tamp",
            url: "https://srapc-under-construction.geodemosolutions.com"
          },
          {
            title: "RAW DATA",
            code: "corridors_raw_data",
            url: "https://app.powerbi.com/reportEmbed?reportId=1e742e57-4838-4dc9-90d5-c4bcd9188571&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Bridges and Tunnels",
        tabs: [
          {
            title: "INVENTORY",
            code: "bridge_tunnel_inventory",
            url: "https://app.powerbi.com/reportEmbed?reportId=443732c7-8cfd-4306-9299-a786405456d0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "CONDITION",
            code: "bridge_tunnel_condition",
            url: "https://app.powerbi.com/reportEmbed?reportId=6f106191-7b64-4e83-90c8-5e97090a8706&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "GIS",
            code: "bridge_tunnel_gis",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=888af4150afd4df7a69a299778e5a59c&preview"
          },
          {
            title: "TAMP",
            code: "bridge_tunnel_tamp",
            url: "https://app.powerbi.com/reportEmbed?reportId=f72c9728-07ac-4274-bb96-741e60bcb694&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "RAW DATA",
            code: "bridge_tunnel_raw_data",
            url: "https://srapc-under-construction.geodemosolutions.com"
          }
        ]
      }
    ],
    asset_performance: [
      {
        title: "ITS",
        tabs: [
          {
            title: "",
            code: "asset_perf_its",
            url: "https://srapc-under-construction.geodemosolutions.com"
          }
        ]
      },
      {
        title: "Pavements",
        tabs: [
          {
            title: "",
            code: "asset_perf_pavements",
            url: "https://app.powerbi.com/reportEmbed?reportId=8ad95f22-af62-4dbe-8683-03454dd50b05&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Corridors",
        tabs: [
          {
            title: "",
            code: "asset_perf_corridors",
            url: "https://app.powerbi.com/reportEmbed?reportId=2256eb33-3427-46a8-a530-04beb897977a&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Bridges and Tunnels",
        tabs: [
          {
            title: "",
            code: "asset_perf_bridges_tunnels",
            url: "https://app.powerbi.com/reportEmbed?reportId=81a21f67-0c26-442b-aaab-77998e1d899d&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Delineation and Signage",
        tabs: [
          {
            title: "",
            code: "asset_perf_del_signage",
            url: "https://app.powerbi.com/reportEmbed?reportId=b602f050-3f75-482f-beae-d4b5d3d580d3&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Traffic Facilities",
        tabs: [
          {
            title: "",
            code: "asset_perf_traffic",
            url: "https://app.powerbi.com/reportEmbed?reportId=03e2614c-0ad9-4d36-8dea-2be41b325f3c&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      }
    ]
  },
  defaultTabs: [
    {
      title: "INSIGHT",
      code: "insight",
      url: "https://app.powerbi.com/reportEmbed?reportId=1fcb7c77-721a-4d62-bce8-ca353cd80e68&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    },
    {
      title: "GIS",
      code: "gis",
      url: "img/assets/tabs/GISTab.png"
    },
    {
      title: "CONOPS",
      code: "conops",
      url: "img/assets/tabs/GISTab.png"
    },
    {
      title: "FMECA",
      code: "fmeca",
      url: "img/assets/tabs/ConopsTab.png"
    },
    {
      title: "RAW DATA",
      code: "raw_data",
      url: "img/assets/tabs/ConopsTab.png"
    }
  ],
  currentSelectedCategory: "",
  currentSelectedSubCategory: "",
  activeElement: "",
  currentSelectedTab: {
  },
  activeTabFlags: {
    overview_river_zoneSection: false,
    overview_data_qualitySection: false,
    comm_feedback_existing_dataSection: false,
    comm_feedback_potential_dataSection: false,
    trfk_perf_existing_dataSection: false,
    trfk_perf_potential_dataSection: false,
    safety_existing_dataSection: false,
    safety_potential_dataSection: false,
    heavy_vhcl_existing_dataSection: false,
    heavy_vhcl_potential_dataSection: false,
    its_inventorySection: false,
    its_conditionSection: false,
    its_gisSection: false,
    its_tampSection: false,
    its_raw_dataSection: false,
    pavements_inventorySection: false,
    pavements_conditionSection: false,
    pavements_gisSection: false,
    pavements_tampSection: false,
    pavements_raw_dataSection: false,
    corridors_inventorySection: false,
    corridors_conditionSection: false,
    corridors_gisSection: false,
    corridors_tampSection: false,
    corridors_raw_dataSection: false,
    bridge_tunnel_inventorySection: false,
    bridge_tunnel_conditionSection: false,
    bridge_tunnel_gisSection: false,
    bridge_tunnel_tampSection: false,
    bridge_tunnel_raw_dataSection: false,
    asset_perf_itsSection: false,
    asset_perf_pavementsSection: false,
    asset_perf_corridorsSection: false,
    asset_perf_bridges_tunnelsSection: false,
    asset_perf_del_signageSection: false,
    asset_perf_trafficSection: false,
    // inventorySection: false,
    // conditionSection: false,
    // gisSection: false,
    // raw_dataSection: false,
    // river_zoneSection: false,
    // data_qualitySection: false,
    // exisitng_dataSection: false,
    // potential_dataSection: false,
    // tampSection: false,
    // itsSection: false,
    // pavementsSection: false,
    // corridorsSection: false,
    // bridges_tunnelsSection: false,
    // del_signageSection: false,
    // trafficSection: false,
  }
}

function initialState() {
  return {
    categories: [
      {
        code: "overview",
        title: "Overview",
        sub: true,
        tabs: []
      },
      {
        code: "network_performance",
        title: "Network Performance Indicators",
        sub: true,
        tabs: []
      },
      {
        code: "asset_data",
        title: "Asset Data",
        sub: true,
        tabs: []
      },
      {
        code: "asset_performance",
        title: "Asset Perfomance Indicators",
        sub: true,
        tabs: []
      }
    ],
    subCategories: {
      overview: [
        {
          title: "River Zone Network Map",
          tabs: [
            {
              title: "",
              code: "overview_river_zone",
              // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=51ffb878a4ae4095a87fcd3f03476bbb"
              url: "https://www.srapc-2d-webapp.geodemosolutions.com/"
            }
          ]
        },
        {
          title: "Data Quality Assessments",
          tabs: [
            {
              title: "",
              code: "overview_data_quality",
              url: "https://app.powerbi.com/reportEmbed?reportId=59f03a19-b23d-4134-b75d-704ab03f46fa&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
      ],
      network_performance: [
        {
          title: "Community Feedback",
          tabs: [
            {
              title: "Existing Data",
              code: "comm_feedback_existing_data",
              url: "https://app.powerbi.com/reportEmbed?reportId=fffce3a5-b188-4f91-b238-22ceb74e99fb&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "Potential Data",
              code: "comm_feedback_potential_data",
              url: "https://app.powerbi.com/reportEmbed?reportId=7c7aca86-5017-4185-ba04-405faf88fcfa&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Traffic Performance",
          tabs: [
            {
              title: "Existing Data",
              code: "trfk_perf_existing_data",
              url: "https://srapc-under-construction.geodemosolutions.com"
            },
            {
              title: "Potential Data",
              code: "trfk_perf_potential_data",
              url: "https://srapc-under-construction.geodemosolutions.com"
            }
          ]
        },
        {
          title: "Safety Data",
          tabs: [
            {
              title: "Existing Data",
              code: "safety_existing_data",
              url: "https://app.powerbi.com/reportEmbed?reportId=0d27b3b4-5162-454d-9db3-3778e9569d9e&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "Potential Data",
              code: "safety_potential_data",
              url: "https://srapc-under-construction.geodemosolutions.com"
            }
          ]
        },
        {
          title: "Heavy Vehicles",
          tabs: [
            {
              title: "Existing Data",
              code: "heavy_vhcl_existing_data",
              url: "https://srapc-under-construction.geodemosolutions.com"
            },
            {
              title: "Potential Data",
              code: "heavy_vhcl_potential_data",
              url: "https://srapc-under-construction.geodemosolutions.com"
            }
          ]
        }
      ],
      asset_data: [
        {
          title: "ITS",
          tabs: [
            {
              title: "INVENTORY",
              code: "its_inventory",
              url: "https://app.powerbi.com/reportEmbed?reportId=dfcb1801-167d-4606-beb0-8bc74a16dd9a&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "CONDITION",
              code: "its_condition",
              url: "https://app.powerbi.com/reportEmbed?reportId=ec12fe5a-85a5-4176-8ab7-9e2cdc686854&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D "
            },
            {
              title: "GIS",
              code: "its_gis",
              url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=99b79f7c61794ae2b0bc55427e5f04a6"
            },
            {
              title: "TAMP",
              code: "its_tamp",
              url: "https://srapc-under-construction.geodemosolutions.com"
            },
            {
              title: "RAW DATA",
              code: "its_raw_data",
              url: "https://app.powerbi.com/reportEmbed?reportId=144591d1-ea08-49bd-9cbb-e416ad2f22e7&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Pavements",
          tabs: [
            {
              title: "INVENTORY",
              code: "pavements_inventory",
              url: "https://app.powerbi.com/reportEmbed?reportId=53a52226-87ff-41b5-844e-4c8bb0760ed7&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "CONDITION",
              code: "pavements_condition",
              url: "https://app.powerbi.com/reportEmbed?reportId=881c07a9-5433-447b-aad8-ca149fb03d56&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "GIS",
              code: "pavements_gis",
              url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=75218493f525483f94e0e1171c70ea12"
            },
            {
              title: "TAMP",
              code: "pavements_tamp",
              url: "https://srapc-under-construction.geodemosolutions.com"
            },
            {
              title: "RAW DATA",
              code: "pavements_raw_data",
              url: "https://app.powerbi.com/reportEmbed?reportId=f046d0d3-dfb6-449e-b07e-389f6b4aa9af&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Corridors",
          tabs: [
            {
              title: "INVENTORY",
              code: "corridors_inventory",
              url: "https://app.powerbi.com/reportEmbed?reportId=3ddde391-2f04-4b1c-bd42-e3be4eaee733&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "CONDITION",
              code: "corridors_condition",
              url: "https://app.powerbi.com/reportEmbed?reportId=28c50666-cf39-4607-a7c4-f0bf93e0b5cc&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "GIS",
              code: "corridors_gis",
              // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=2b887c7f3066445e91917e4fafcbe891"
              url: "https://www.srapc-asset-corridors-webapp.geodemosolutions.com/"
            },
            {
              title: "TAMP",
              code: "corridors_tamp",
              url: "https://srapc-under-construction.geodemosolutions.com"
            },
            {
              title: "RAW DATA",
              code: "corridors_raw_data",
              url: "https://app.powerbi.com/reportEmbed?reportId=1e742e57-4838-4dc9-90d5-c4bcd9188571&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Bridges and Tunnels",
          tabs: [
            {
              title: "INVENTORY",
              code: "bridge_tunnel_inventory",
              url: "https://app.powerbi.com/reportEmbed?reportId=443732c7-8cfd-4306-9299-a786405456d0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "CONDITION",
              code: "bridge_tunnel_condition",
              url: "https://app.powerbi.com/reportEmbed?reportId=6f106191-7b64-4e83-90c8-5e97090a8706&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "GIS",
              code: "bridge_tunnel_gis",
              url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=888af4150afd4df7a69a299778e5a59c&preview"
            },
            {
              title: "TAMP",
              code: "bridge_tunnel_tamp",
              url: "https://app.powerbi.com/reportEmbed?reportId=f72c9728-07ac-4274-bb96-741e60bcb694&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "RAW DATA",
              code: "bridge_tunnel_raw_data",
              url: "https://srapc-under-construction.geodemosolutions.com"
            }
          ]
        }
      ],
      asset_performance: [
        {
          title: "ITS",
          tabs: [
            {
              title: "",
              code: "asset_perf_its",
              url: "https://srapc-under-construction.geodemosolutions.com"
            }
          ]
        },
        {
          title: "Pavements",
          tabs: [
            {
              title: "",
              code: "asset_perf_pavements",
              url: "https://app.powerbi.com/reportEmbed?reportId=8ad95f22-af62-4dbe-8683-03454dd50b05&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Corridors",
          tabs: [
            {
              title: "",
              code: "asset_perf_corridors",
              url: "https://app.powerbi.com/reportEmbed?reportId=2256eb33-3427-46a8-a530-04beb897977a&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Bridges and Tunnels",
          tabs: [
            {
              title: "",
              code: "asset_perf_bridges_tunnels",
              url: "https://app.powerbi.com/reportEmbed?reportId=81a21f67-0c26-442b-aaab-77998e1d899d&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Delineation and Signage",
          tabs: [
            {
              title: "",
              code: "asset_perf_del_signage",
              url: "https://app.powerbi.com/reportEmbed?reportId=b602f050-3f75-482f-beae-d4b5d3d580d3&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Traffic Facilities",
          tabs: [
            {
              title: "",
              code: "asset_perf_traffic",
              url: "https://app.powerbi.com/reportEmbed?reportId=03e2614c-0ad9-4d36-8dea-2be41b325f3c&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        }
      ]
    },
    defaultTabs: [
      {
        title: "INSIGHT",
        code: "insight",
        url: "https://app.powerbi.com/reportEmbed?reportId=1fcb7c77-721a-4d62-bce8-ca353cd80e68&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      },
      {
        title: "GIS",
        code: "gis",
        url: "img/assets/tabs/GISTab.png"
      },
      {
        title: "CONOPS",
        code: "conops",
        url: "img/assets/tabs/GISTab.png"
      },
      {
        title: "FMECA",
        code: "fmeca",
        url: "img/assets/tabs/ConopsTab.png"
      },
      {
        title: "RAW DATA",
        code: "raw_data",
        url: "img/assets/tabs/ConopsTab.png"
      }
    ],
    currentSelectedCategory: "",
    currentSelectedSubCategory: "",
    activeElement: "",
    currentSelectedTab: {
    },
    activeTabFlags: {
      overview_river_zoneSection: false,
      overview_data_qualitySection: false,
      comm_feedback_existing_dataSection: false,
      comm_feedback_potential_dataSection: false,
      trfk_perf_existing_dataSection: false,
      trfk_perf_potential_dataSection: false,
      safety_existing_dataSection: false,
      safety_potential_dataSection: false,
      heavy_vhcl_existing_dataSection: false,
      heavy_vhcl_potential_dataSection: false,
      its_inventorySection: false,
      its_conditionSection: false,
      its_gisSection: false,
      its_tampSection: false,
      its_raw_dataSection: false,
      pavements_inventorySection: false,
      pavements_conditionSection: false,
      pavements_gisSection: false,
      pavements_tampSection: false,
      pavements_raw_dataSection: false,
      corridors_inventorySection: false,
      corridors_conditionSection: false,
      corridors_gisSection: false,
      corridors_tampSection: false,
      corridors_raw_dataSection: false,
      bridge_tunnel_inventorySection: false,
      bridge_tunnel_conditionSection: false,
      bridge_tunnel_gisSection: false,
      bridge_tunnel_tampSection: false,
      bridge_tunnel_raw_dataSection: false,
      asset_perf_itsSection: false,
      asset_perf_pavementsSection: false,
      asset_perf_corridorsSection: false,
      asset_perf_bridges_tunnelsSection: false,
      asset_perf_del_signageSection: false,
      asset_perf_trafficSection: false,
      // inventorySection: false,
      // conditionSection: false,
      // gisSection: false,
      // raw_dataSection: false,
      // river_zoneSection: false,
      // data_qualitySection: false,
      // exisitng_dataSection: false,
      // potential_dataSection: false,
      // tampSection: false,
      // itsSection: false,
      // pavementsSection: false,
      // corridorsSection: false,
      // bridges_tunnelsSection: false,
      // del_signageSection: false,
      // trafficSection: false,
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    Object.keys(state.activeTabFlags).forEach(item=>{
      state.activeTabFlags[item] = false
    })
    console.log(state.activeTabFlags);
    console.log(payload);
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setActiveSidebarElement(state, payload) {
    state.activeElement = payload
  },
  setCurrentSelectedCategory(state, payload) {
    state.currentSelectedCategory = payload
  },
  setCurrentSelectedTab(state, payload) {
    // if(payload.title != "Overview"){
    //
    //   // if(state.currentSelectedSubCategory == "Noisewall"){
    //   if(state.subCategories[state.currentSelectedCategory.code].filter(obj=>obj.title == state.currentSelectedSubCategory)[0].tabs.length == 0){
    //     payload.tabs = state.defaultTabs
    //   }
    //   // else{
    //   //   payload.tabs = state.defaultTabs
    //   // }
    //
    // }
    state.currentSelectedTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
